import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Profile from './pages/Profile';
import web3 from './ethereum/web3';
import Web3Modal from 'web3modal';
import Footer from './components/Footer/Footer';

let provider;

const web3Modal = new Web3Modal({
    // network: "mainnet", // optional
    cacheProvider: true, // optional
    providerOptions: {}, // required
});

function App() {
    const [account, setaccount] = useState('');

    useEffect(() => {
        onConnectWallet();
        // const getAccount = async () => {
        //     console.log(web3);
        //     const accounts = await web3.eth.getAccounts();
        //     console.log('account in header: ', accounts[0]);
        //     // setaccount(accounts[0]);
        // };
        // getAccount();
    }, []);

    useEffect(() => {
        async function listenMMAccount() {
            window.ethereum.on('accountsChanged', async function () {
                // Time to reload your interface with accounts[0]!
                const account = await web3.eth.getAccounts();
                setaccount(account[0]);
                // accounts = await web3.eth.getAccounts();
                // console.log(account);
            });

            window.ethereum.on('networkChanged', function (networkId) {
                // Time to reload your interface with the new networkId
                window.location.reload();
            });
        }
        listenMMAccount();
    }, []);

    const onConnectWallet = async () => {
        // e.preventDefault();
        // console.log('connecting wallet...');
        // console.log('cached provider', web3Modal.cachedProvider);
        try {
            provider = await web3Modal.connect();
            // console.log('provider: ', provider);
        } catch (err) {
            // console.log('Could not get a wallet connection', err);
            console.error(err);
            return;
        }
        web3.setProvider(provider);
        const accounts = await web3.eth.getAccounts();
        setaccount(accounts[0]);
    };

    const onDisconnect = async (e) => {
        e.preventDefault();

        // console.log(
        //     'cached provider before provider.close(): ',
        //     web3Modal.cachedProvider
        // );
        // console.log('Killing the session', web3.currentProvider);
        // console.log('web3.givenProvider', web3.givenProvider);

        if (web3 && web3.currentProvider && web3.currentProvider.close) {
            await web3.currentProvider.close();
        }

        // console.log(
        //     'cached provider after provider.close(): ',
        //     web3Modal.cachedProvider
        // );
        await web3Modal.clearCachedProvider();
        // console.log('cached provider after clear: ', web3Modal.cachedProvider);
        provider = null;
        // setaccount("");
        // window.location.reload(); // removing for a while
    };

    return (
        <div>
            <Header
                account={account}
                onConnectWallet={onConnectWallet}
                onDisconnect={onDisconnect}
            />
            <Switch>
                <Route
                    exact
                    path="/"
                    component={() => <Home account={account} />}
                />
                <Route
                    exact
                    path="/:id"
                    component={() => <Profile account={account} />}
                />
            </Switch>
            <Footer />
        </div>
    );
}

export default App;
